export class FileUploadSingleController {

  constructor($scope, $confirm) {
    this.$scope = $scope
    $scope.setValue = this.setValue.bind(this)
    $scope.clearValue = this.clearValue.bind(this)
    this.$confirm = $confirm
  }

  clearValue() {
    this.$confirm({
      text: 'Are you sure you want to remove this file?'
    }).then(() => {
      this.setValue(undefined)
    })
  }

  setValue(value) {
    this.$scope.model[this.$scope.options.key] = value
  }
}

FileUploadSingleController.$inject = ['$scope', '$confirm']